import { css } from '@emotion/react';

export const dialogHide = css`
  visibility: hidden;
  opacity: 0;
  transform: translateX(-50%) translateY(calc(-50% - 8px));
`;

export const dialogShow = css`
  visibility: visible;
  opacity: 1;
  transform: translate(-50%, -50%);
`;

export const backdropHide = css`
  visibility: hidden;
  opacity: 0;
`;

export const backdropShow = css`
  visibility: visible;
  opacity: 0.9;
`;

export const root = (size: string) => css`
  position: fixed;
  top: 50%;
  left: 50%;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  transition: all 0.3s ease;
  width: ${size}px;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  background-color: white;
  z-index: var(--z-dialog);

  /* for IE 11 */
  -ms-overflow-style: none;
`;

export const backdrop = css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--gray-600);
  transition: all 0.3s ease;
  z-index: var(--z-dialog);
  mix-blend-mode: multiply;
`;

export const title = css`
  display: flex;
  justify-content: space-between;
  padding: 24px 24px;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.2px;
  font-weight: bold;
  color: #343a40;
  border-bottom: 1px solid var(--gray-200);

  & > img {
    cursor: pointer;
  }
`;

export const noTitle = css`
  justify-content: flex-end;
  border-bottom: 0;
  padding-bottom: 8px;
`;

export const titleContent = css`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const titleAction = css`
  display: flex;
  align-items: center;
`;

export const titleActionText = css`
  color: var(--blue-500);
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: -0.2px;
  margin-right: 24px;
  cursor: pointer;
`;

export const content = (height: 'auto' | number) => css`
  height: ${`${height === 'auto' ? 'auto' : `${height}px`}`};
  overflow: auto;
  padding: 24px;
`;

export const noTitleContent = css`
  padding-top: 0px;
`;

export const footer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid var(--gray-200);
`;

export const buttonGroup = css`
  display: flex;
  flex-direction: row;
  & > span:first-of-type {
    margin-right: 8px;
  }
  & > span:last-of-type {
    margin-right: 0;
  }
`;

export const additionalInfo = css`
  display: flex;
  flex-direction: column;
`;

export const additionalTitle = css`
  color: var(--gray-500);
  font-size: 13px;
  line-height: 16px;
  letter-spacing: -0.2px;
  text-align: left;
`;

export const additionalContent = css`
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const optionButton = css`
  margin-right: 8px;
`;
